import React from 'react';
import {
  takeLatest,
  takeLeading,
  call,
  put,
  takeEvery
} from 'redux-saga/effects';
import { FormattedMessage } from 'react-intl';
import dataApi from '../../apis/dataApi';
import nirServiceApi from '../../apis/nirServiceApi';
import { notify } from '../notificationSystem/actions';
import * as constants from './constants';
import * as actions from './actions';
import * as appAct from '../app/actions';
import handleError from '../handleError';
import { globalMarketReviewRoute, globalReviewApprovalRoute } from 'routes';

export function* fetchPpsi(action) {
  try {
    const id = action.payload;
    const response = yield call(dataApi.fetchPpsi, id);
    const ppsi = response.data;
    yield put(actions.fetchPpsiDone(ppsi));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsiFetchFail',
      put(actions.fetchPpsisFail(error))
    );
  }
}

export function* deletePpsi(action) {
  try {
    const id = action.payload;
    const response = yield call(dataApi.deletePpsi, id);

    const { data } = response.data;
    const isResponseValid =
      data !== null && data !== undefined && data.length !== 0;
    yield put(actions.deletePpsiDone(isResponseValid ? data : []));
    yield put(
      notify({
        message: response.data.message,
        variant: 'success'
      })
    );
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsiDeleteFail',
      put(actions.deletePpsiFail(error))
    );
  }
}

// create ppsi variant

export function* createPpsiVariant(action) {
  try {
    const { id, status } = action.payload;
    const response = yield call(dataApi.createVariantPpsi, id, status);

    const { data } = response;
    yield put(actions.createPpsiVariantDone(data));
    yield put(
      notify({
        message: [
          <FormattedMessage
            id="notify.ppsiCreateVariantSuccess"
            key="success"
          />
        ],
        variant: 'success'
      })
    );
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsiCreateVariantFail',
      put(actions.createPpsiVariantFail(error))
    );
  }
}

export function* fetchPpsis(action) {
  try {
    const filter = action.payload;
    const response = yield call(dataApi.fetchPpsis, filter);
    yield put(actions.fetchPpsisDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsisFetchFail',
      put(actions.fetchPpsisFail(error))
    );
  }
}

export function* fetchPublishedUnpublishedPpsis() {
  try {
    const response = yield call(dataApi.fetchPublishedUnpublishedPpsis);
    yield put(actions.fetchPublishedUnpublishedPpsisDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsisFetchFail',
      put(actions.fetchPublishedUnpublishedPpsisFail(error))
    );
  }
}

export function* fetchGlobalPpsi(action) {
  try {
    const id = action.payload;
    if (id !== null) {
      const response = yield call(dataApi.fetchGlobalPpsi, id);
      const ppsi = response.data;
      yield put(actions.fetchPpsiDone(ppsi));
    }
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsiFetchGlobalFail',
      put(actions.fetchPpsisFail(error))
    );
  }
}

// fetch review pending PPSI with status
export function* fetchReviewPpsis(action) {
  try {
    const { filter, marketCode } = action.payload;
    const response = yield call(dataApi.fetchReviewPpsis, filter, marketCode);
    yield put(actions.fetchReviewPpsisDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsisFetchFail',
      put(actions.fetchReviewPpsisFail(error))
    );
  }
}

// fetch range statistics dish reports for markets.
export function* fetchRangeStatisticsReport(action) {
  try {
    const { market } = action.payload;
    const response = yield call(dataApi.fetchRangeStatistics, market);
    yield put(actions.totalRangePpsiDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.rangeReportFetchFail',
      put(actions.totalRangePpsiFail(error))
    );
  }
}

// fetch PPSI for global approval
export function* fetchGlobalApprovalPpsi(action) {
  try {
    const { marketCode, id } = action.payload;
    const response = yield call(
      dataApi.fetchGlobalApprovalPpsi,
      marketCode,
      id
    );
    yield put(actions.fetchGlobalApprovalPpsiDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsisFetchFail',
      put(actions.fetchGlobalApprovalPpsiFail(error))
    );
  }
}

export function* fetchGlobalPpsis() {
  try {
    const response = yield call(dataApi.fetchGlobalPpsis);
    yield put(actions.fetchPpsisDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsisFetchGlobalFail',
      put(actions.fetchPpsisFail(error))
    );
  }
}

export function* fetchPpsisUpdates() {
  try {
    const response = yield call(dataApi.fetchPpsisUpdates);
    // yield put(actions.fetchPpsisUpdatesDone(response.data));
    yield put(actions.fetchPpsisDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsisFetchUpdatesFail',
      put(actions.fetchPpsisUpdatesFail(error))
    );
  }
}

export function* fetchGlobalPpsisUpdates() {
  try {
    const response = yield call(dataApi.fetchGlobalPpsisUpdates);
    // yield put(actions.fetchGlobalPpsisUpdatesDone(response.data));
    yield put(actions.fetchPpsisDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsisFetchGlobalUpdatesFail',
      put(actions.fetchGlobalPpsisUpdatesFail(error))
    );
  }
}

export function* fetchGlobalNewPpsis() {
  try {
    const response = yield call(dataApi.fetchGlobalNewPpsis);
    yield put(actions.fetchPpsisDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsisFetchGlobalFail',
      put(actions.fetchPpsisFail(error))
    );
  }
}

export function* createPpsi(action) {
  const { formulaCode, ppsi, callback, productAreaData } = action.payload;

  try {
    const response = yield call(dataApi.createPpsi, formulaCode, ppsi);

    if (productAreaData) {
      yield call(
        nirServiceApi.saveProductArea,
        response.data.id,
        productAreaData
      );
    }

    yield put(actions.createPpsiDone(response.data));

    if (callback) {
      callback(true);
    }
    yield put(
      notify({
        message: [
          <FormattedMessage id="notify.ppsiSaveSuccess" key="success" />
        ],
        variant: 'success'
      })
    );
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsiSaveFail',
      put(actions.createPpsiFail(error))
    );
    if (callback) {
      callback(false);
    }
  }
}

// fetch PPSI Global review summary

export function* fetchPpsisReviewSummary(action) {
  try {
    let response = '';
    if (action.payload) {
      response = yield call(
        dataApi.fetchPpsisReviewSummary,
        action.payload.market
      );
      if (action.payload.count > response.data[0].NoofObjects) {
        yield put(actions.hasRecalledPPSIError(true));
      } else {
        action.payload.history.push(
          globalMarketReviewRoute(action.payload.market)
        );
      }
    } else {
      response = yield call(dataApi.fetchPpsisReviewSummary);
    }
    yield put(
      actions.fetchPpsisReviewSummaryDone(response.data, action.payload)
    );
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsiFetchReviewSummaryFail',
      put(actions.fetchPpsisReviewSummaryFail(error))
    );
  }
}

export function* fetchNumberOfObjectsForReview(action) {
  try {
    const response = yield call(
      dataApi.fetchPpsisReviewSummary,
      action.payload.market
    );
    yield put(
      actions.navigateToReviewPageDone({
        count: response.data[0].NoofObjects,
        market: action.payload.market
      })
    );

    if (action.payload.count > response.data[0].NoofObjects) {
      yield put(actions.hasRecalledPPSIError(true));
    } else {
      // action.payload.history.push(
      //   globalMarketReviewRoute(action.payload.market)
      // );
    }
    // yield put(
    //   actions.navigateToReviewPageDone()
    // );
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsiFetchReviewSummaryFail',
      put(actions.navigateToReviewPageFail(error))
    );
  }
}

export function* savePpsi(action) {
  try {
    const { id, ppsi, callback, productAreaData } = action.payload;
    const response = yield call(dataApi.savePpsi, id, ppsi);

    if (productAreaData) {
      yield call(nirServiceApi.saveProductArea, id, productAreaData);
    }

    yield put(actions.savePpsiDone(response.data));

    if (callback) {
      callback(true);
    }
    yield put(
      notify({
        message: [
          <FormattedMessage id="notify.ppsiSaveSuccess" key="success" />
        ],
        variant: 'success'
      })
    );
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsiSaveFail',
      put(actions.savePpsiFail(error))
    );

    const { callback } = action.payload;
    if (callback) {
      callback(true);
    }
  }
}

export function* approvePpsiNir(action) {
  try {
    const { id, data } = action.payload;

    yield call(nirServiceApi.publishProductArea, id);

    const response = yield call(dataApi.approvePpsi, id, data);

    yield put(actions.approvePpsiDone(response.data));

    // yield put(
    //   notify({
    //     message: [
    //       <FormattedMessage id="notify.ppsiApproveSuccess" key="success" />
    //     ],
    //     variant: 'success'
    //   })
    // );
    yield put(
      sendSuccessNotification(
        response.data.inProgressPpsiEnrichmentData &&
          response.data.inProgressPpsiEnrichmentData.status === 'SCHEDULED'
          ? 'notify.ppsiSchedulePublishSuccess'
          : 'notify.ppsiApproveSuccess'
      )
    );
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsiApproveFail',
      put(actions.approvePpsiFail(error))
    );
  }
}

// API for global to approve market PPSI
export function* globalApprovesPpsi(action) {
  try {
    const { marketCode, id } = action.payload;
    const response = yield call(dataApi.globalApprovePpsi, marketCode, id);
    yield put(actions.approveGlobalReviewPpsiDone(response.data));
    yield put(
      notify({
        message: [
          <FormattedMessage
            id="notify.ppsiGlobalApproveSuccess"
            key="success"
          />
        ],
        variant: 'success'
      })
    );
  } catch (error) {
    if (error.response.data.message.includes('recall')) {
      yield put(actions.hasRecalledPPSIError(true));
      yield put(actions.approveGlobalReviewPpsiFail(error));
    } else {
      yield call(
        handleError,
        error,
        'notify.ppsiGlobalApproveFail',
        put(actions.approveGlobalReviewPpsiFail(error))
      );
    }
  }
}

export function* getRecalledError(action) {
  try {
    const { id, history } = action.payload;
    const response = yield call(dataApi.fetchRecalledError, id);
    if (response.data[0].enrichmentStatus === constants.States.GLOBALREVIEW) {
      yield put(actions.fetchRecalledErrorForOneDone(false));
      history.push(globalReviewApprovalRoute(id));
    } else {
      yield put(actions.fetchRecalledErrorForOneDone(true));
      yield put(actions.hasRecalledPPSIError(true));
    }
  } catch (error) {
    // yield call(
    //   handleError,
    //   error,
    //   'notify.ppsiGlobalApproveFail',
    //   put(actions.fetchRecalledErrorForOneFail(error))
    // );
  }
}

// API for global to reject market PPSI
export function* globalRejectsPpsi(action) {
  try {
    const { id, data } = action.payload;
    const response = yield call(dataApi.globalRejectPpsi, id, data);
    yield put(actions.rejectGlobalReviewPpsiDone(response.data));
    yield put(
      notify({
        message: [
          <FormattedMessage id="notify.ppsiGlobalRejectSuccess" key="success" />
        ],
        variant: 'success'
      })
    );
  } catch (error) {
    if (error.response.data.message.includes('recall')) {
      yield put(actions.hasRecalledPPSIError(true));
    } else {
      yield call(
        handleError,
        error,
        'notify.ppsiGlobalRejectFail',
        put(actions.rejectGlobalReviewPpsiFail(error))
      );
    }
  }
}

// API for local admin to send PPSI for global approval.
export function* sendPpsiForGlobalApprove(action) {
  try {
    const { id, data } = action.payload;
    data.isUpdateSelected =
      data.versionComments.isUpdateSelected !== undefined
        ? data.versionComments.isUpdateSelected
        : true;
    delete data.versionComments.isUpdateSelected;
    const response = yield call(dataApi.sendForGlobalReviewPpsi, id, data);
    yield put(actions.sendPpsiForGlobalReviewDone(response.data));
    yield put(
      notify({
        message: [
          <FormattedMessage id="notify.ppsiSubmitReviewSuccess" key="success" />
        ],
        variant: 'success'
      })
    );
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsiSubmitReviewFail',
      put(actions.sendPpsiForGlobalReviewFail(error))
    );
  }
}

// fetch ppsi with global statusin local market

export function* fetchGlobalStatusPpsi() {
  try {
    const response = yield call(dataApi.fetchGlobalStatusPpsis);
    yield put(actions.fetchGlobalStatusPpsiDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsiWithGlobalStatusFail',
      put(actions.fetchGlobalStatusPpsiFail(error))
    );
  }
}

const ApiActionType = {
  APPROVE: {
    dataApiMethod: dataApi.approvePpsi,
    reduxActionDone: actions.approvePpsiDone,
    reduxActionFail: actions.approvePpsiFail,
    successMessage: 'notify.ppsiApproveSuccess',
    failMessage: 'notify.ppsiApproveFail'
  },
  PUBLISH: {
    dataApiMethod: dataApi.publishPpsi,
    reduxActionDone: actions.publishPpsiDone,
    reduxActionFail: actions.publishPpsiFail,
    successMessage: 'notify.ppsiPublishSuccess',
    failMessage: 'notify.ppsiPublishFail'
  },
  // IFPPSI-954 - Publish empty PPSI option for global admin;
  PUBLISH_EMPTY_PPSI: {
    dataApiMethod: dataApi.publishEmptyPpsi,
    reduxActionDone: actions.publishEmptyPpsiDone,
    reduxActionFail: actions.publishEmptyPpsiFail,
    successMessage: 'notify.ppsiPublishSuccess',
    failMessage: 'notify.ppsiPublishFail'
  },

  UNPUBLISH: {
    dataApiMethod: dataApi.unpublishPpsi,
    reduxActionDone: actions.unpublishPpsiDone,
    reduxActionFail: actions.unpublishPpsiFail,
    successMessage: 'notify.ppsiUnpublishSuccess',
    failMessage: 'notify.ppsiUnpublishFail'
  },
  MARKASUPTODATE: {
    dataApiMethod: dataApi.markAsUptoDatePpsi,
    reduxActionDone: actions.markAsUptoDatePpsiDone,
    reduxActionFail: actions.markAsUptoDatePpsiFail,
    successMessage: 'notify.ppsiMarkAsUptoDateSuccess',
    failMessage: 'notify.ppsiMarkAsUptoDateFail'
  },
  CREATE_DRAFT: {
    dataApiMethod: dataApi.createDraftPpsi,
    reduxActionDone: actions.createDraftPpsiDone,
    reduxActionFail: actions.createDraftPpsiFail,
    successMessage: 'notify.ppsiCreateDraftSuccess',
    failMessage: 'notify.ppsiCreateDraftFail'
  },
  IMPORT_IFOOD_UPDATE_PPSI_API: {
    dataApiMethod: dataApi.importiFoodUpdatePpsi,
    reduxActionDone: actions.importiFoodUpdatePpsiDone,
    reduxActionFail: actions.importiFoodUpdatePpsiFail,
    successMessage: 'notify.ppsiIFoodUpdateImportUpdateSuccess',
    failMessage: 'notify.ppsiIFoodUpdateImportUpdateFail'
  },
  IMPORT_GLOBAL_UPDATE_PPSI: {
    dataApiMethod: dataApi.importGlobalPpsiUpdate,
    reduxActionDone: actions.importGlobalUpdatePpsiDone,
    reduxActionFail: actions.importGlobalUpdatePpsiFail,
    successMessage: 'notify.ppsiGlobalUpdateImportUpdateSuccess',
    failMessage: 'notify.ppsiGlobalUpdateImportUpdateFail'
  },
  DISCARD_DRAFT_PPSI: {
    dataApiMethod: dataApi.discardDraftPpsi,
    reduxActionDone: actions.discardDraftPpsiDone,
    reduxActionFail: actions.discardDraftPpsiFail,
    successMessage: 'notify.ppsiDiscardDraftSuccess',
    failMessage: 'notify.ppsiDiscardDraftFail'
  }
};

function sendSuccessNotification(messageId) {
  return notify({
    message: [<FormattedMessage id={messageId} key="success" />],
    variant: 'success'
  });
}

function* performDataApiCall({ payload }, apiActionType) {
  try {
    const { id, data, status } = payload;
    const response = yield call(apiActionType.dataApiMethod, id, data);
    yield put(apiActionType.reduxActionDone(response.data));
    if (
      !(
        apiActionType.successMessage === 'notify.ppsiCreateDraftSuccess' &&
        (status === constants.States.SCHEDULED ||
          status === constants.States.GLOBALREVIEW)
      )
    ) {
      //yield put(sendSuccessNotification(apiActionType.successMessage));
      yield put(
        sendSuccessNotification(
          response.data.inProgressPpsiEnrichmentData &&
            response.data.inProgressPpsiEnrichmentData.status === 'SCHEDULED'
            ? 'notify.ppsiSchedulePublishSuccess'
            : apiActionType.successMessage
        )
      );
    }
  } catch (error) {
    yield call(
      handleError,
      error,
      apiActionType.failMessage,
      put(apiActionType.reduxActionFail(error))
    );
  }
}

function* approvePpsi(reduxAction) {
  yield call(performDataApiCall, reduxAction, ApiActionType.APPROVE);
}

// IFPPSI-954 - Publish empty PPSI option for global admin;

function* publishEmptyPpsi(reduxAction) {
  yield call(performDataApiCall, reduxAction, ApiActionType.PUBLISH_EMPTY_PPSI);
}

// Approve PPSI with schdule and success message based on response.
// export function* approvePpsi(action) {
//   try {
//     const { id, data } = action.payload;
//     const response = yield call(dataApi.approvePpsi, id, data);
//     const checkMessage = response.data.inProgressPpsiEnrichmentData === null;

//     yield put(actions.approvePpsiDone(response.data));
//     yield put(
//       notify({
//         message: [
//           <FormattedMessage id={checkMessage? "notify.ppsiApproveSuccess"
//           : "notify.ppsiSchedulePublishSuccess"} key="success" />
//         ],
//         variant: 'success'
//       })
//     );
//   } catch (error) {
//     yield call(
//       handleError,
//       error,
//       'notify.ppsiApproveFail',
//       put(actions.approvePpsiFail(error))
//     );
//   }
// }

function* publishPpsi(reduxAction) {
  yield call(performDataApiCall, reduxAction, ApiActionType.PUBLISH);
}

function* unpublishPpsi(reduxAction) {
  yield call(performDataApiCall, reduxAction, ApiActionType.UNPUBLISH);
}

function* markAsUptoDatePpsi(reduxAction) {
  yield call(performDataApiCall, reduxAction, ApiActionType.MARKASUPTODATE);
}

function* createDraftPpsi(reduxAction) {
  yield call(performDataApiCall, reduxAction, ApiActionType.CREATE_DRAFT);
}

// IMPORT IFOOD PPSI UPDATE
function* importiFoodUpdatePpsi(reduxAction) {
  // console.log('Saga.importiFoodUpdatePpsi()', reduxAction);

  yield call(
    performDataApiCall,
    reduxAction,
    ApiActionType.IMPORT_IFOOD_UPDATE_PPSI_API
  );
}

// PPSI DISCARD DRAFT
function* discardDraftPpsi(reduxAction) {
  yield call(performDataApiCall, reduxAction, ApiActionType.DISCARD_DRAFT_PPSI);
}

// IMPORT GLOBAL PPSI UPDATE

function* importGlobalUpdatePpsi(reduxAction) {
  yield call(
    performDataApiCall,
    reduxAction,
    ApiActionType.IMPORT_GLOBAL_UPDATE_PPSI
  );
}

// fetch co-worker engagement report.
export function* fetchCoWorkerEngagementViewReport(action) {
  try {
    const response = yield call(
      dataApi.fetchCoWorkerEngagementReports,
      action.payload
    );
    yield put(actions.fetchCoWorkerEngagementReportDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.engagementReportFetchFail',
      put(actions.fetchCoWorkerEngagementReportFail(error))
    );
  }
}
// fetch co-worker engagement report Market List.
export function* fetchCoWorkerEngagementReportMarketList(action) {
  try {
    const response = yield call(
      dataApi.fetchCoWorkerEngagementReportsMarketList,
      action.payload
    );
    yield put(
      actions.fetchCoWorkerEngagementReportMarketListDone(response.data)
    );
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.engagementReportMarketListFetchFail',
      put(actions.fetchCoWorkerEngagementReportMarketListFail(error))
    );
  }
}

function* uploadBomReport(action) {
  try {
    const response = yield call(nirServiceApi.uploadBomReport, action.payload);
    yield put(actions.uploadBomReportSuccess(response.data.message));
  } catch (error) {
    yield call(
      handleError,
      error || 'Unknown error',
      'notify.bomUploadFail',
      put(
        actions.uploadBomReportFailure(
          error.response.data.message || error.message || 'Unknown error'
        )
      )
    );
  }
}

function* fetchGlobalPpsisNir(action) {
  const { status, toLocalLanguage } = action.payload;

  try {
    const response = yield call(
      dataApi.fetchGlobalPublishedPpsisNir,
      status,
      toLocalLanguage
    );
    yield put(actions.fetchGlobalPpsisNirDone(response.data));
  } catch (error) {
    yield put(actions.fetchGlobalPpsisNirFail(error));
  }
}

const transformPiaProductAreas = piaProductAreas => {
  const grouped = {};
  if (!piaProductAreas.length) {
    return null;
  }
  piaProductAreas.forEach(item => {
    const headerKey = `${item.praNo} - ${item.praDescription}`;

    if (!grouped[headerKey]) {
      grouped[headerKey] = [];
    }

    grouped[headerKey].push({
      value: {
        piaProductArea: item.paNo,
        piaProductAreaName: item.paDescription,
        piaRangeArea: item.praNo,
        piaRangeAreaName: item.praDescription
      },
      label: `${item.paNo} - ${item.paDescription}`
    });
  });

  const result = Object.entries(grouped).map(([header, options]) => ({
    header,
    options
  }));

  return result;
};

function* fetch_PA_RA_Nir() {
  try {
    const response = yield call(nirServiceApi.getProductArea);
    let piaProductAreas = response.data.productAreasResponse.length
      ? transformPiaProductAreas(response.data.productAreasResponse)
      : [];

    yield put(actions.fetchRaPaNirDone(piaProductAreas));
  } catch (error) {
    yield put(actions.fetchRaPaNirFail(error));
  }
}

export function* createPpsiFromGlobalNir(action) {
  const {
    formulaCode,
    ppsi,
    productAreaData,
    globalPiaArticleNumber,
    callback
  } = action.payload;
  try {
    const response = yield call(dataApi.createPpsi, formulaCode, ppsi);

    yield call(
      nirServiceApi.setPpsiGlobal,
      globalPiaArticleNumber,
      response.data.id
    );

    yield call(
      nirServiceApi.saveProductArea,
      response.data.id,
      productAreaData
    );

    yield put(actions.createPpsiDone(response.data));
    if (callback) {
      callback(true);
    }
    yield put(
      notify({
        message: [
          <FormattedMessage id="notify.ppsiSaveSuccess" key="success" />
        ],
        variant: 'success'
      })
    );
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsiSaveFail',
      put(actions.createPpsiFail(error))
    );
    if (callback) {
      callback(false);
    }
  }
}

export function* discardDraftPpsiNir(action) {
  const { id, formulaCode } = action.payload;
  try {
    const response = yield call(dataApi.discardDraftPpsi, id);
    yield call(nirServiceApi.revertToMarketDish, formulaCode);
    yield put(actions.discardDraftPpsiDone(response.data));
    yield put(
      notify({
        message: [
          <FormattedMessage id="notify.ppsiDiscardDraftSuccess" key="success" />
        ],
        variant: 'success'
      })
    );
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsiDiscardDraftFail',
      put(actions.discardDraftPpsiFail(error))
    );
  }
}

export function* deletePpsiNir(action) {
  const { ids, formulaCodes } = action.payload;
  try {
    const response = yield call(dataApi.deletePpsi, ids);
    yield call(nirServiceApi.revertToMarketDish, formulaCodes);

    const { data } = response.data;
    const isResponseValid =
      data !== null && data !== undefined && data.length !== 0;
    yield put(actions.deletePpsiDone(isResponseValid ? data : []));
    yield put(
      notify({
        message: response.data.message,
        variant: 'success'
      })
    );
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.ppsiDeleteFail',
      put(actions.deletePpsiFail(error))
    );
  }
}

// //Fetch global PPi IFS Market for local market
// function* fetchGlobalPpisIfs(action) {
//   const id = action.payload;

//   try {
//     const response = yield call(dataApi.fetchGlobalPublishedPpiIfs, id);
//     yield put(actions.fetchGlobalPpiIfsDone(response.data));
//   } catch (error) {
//     //yield put(actions.fetchGlobalPpiIfsFail(error));
//     yield put(actions.fetchGlobalPpiIfsDone([]));
//   }
// }

// Fetch Market Dish Logo
function* fetchMarketDishLogo() {
  try {
    const response = yield call(dataApi.fetchMarketDishLogo);
    yield put(actions.fetchMarketDishLogoDone(response.data));
  } catch (error) {
    // yield put(actions.fetchMarketDishLogoFail(error));
    yield call(
      handleError,
      error,
      'notify.ppsiFetchFail',
      put(actions.fetchMarketDishLogoFail(error))
    );
  }
}
// save availability tab
export function* saveAvailabilityTab(action) {
  try {
    const { id, status, data, callback } = action.payload;
    const response = yield call(dataApi.saveAvailabilityTab, id, status, data);
    yield put(actions.saveAvailabilityTabDone(response.data));
    yield put(
      notify({
        message: [
          <FormattedMessage
            id="notify.salesAndStoreSaveSuccess"
            key="success"
          />
        ],
        variant: 'success'
      })
    );
    yield put(appAct.setDataNotDirty());
    // if (callback) {
    //   callback(false);
    // }
    yield put(actions.fetchPpsi(id));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.salesAndStoreSaveFail',
      put(actions.saveAvailabilityTabFail(error))
    );
  }
}
export default [
  takeEvery(constants.FETCH_REVIEW_PPSIS, fetchReviewPpsis),
  takeLatest(constants.FETCH_TOTAL_RANGE_REPORT, fetchRangeStatisticsReport),
  takeLatest(
    constants.FETCH_CO_WORKER_ENGAGEMENT_REPORT,
    fetchCoWorkerEngagementViewReport
  ),
  takeLatest(
    constants.FETCH_CO_WORKER_ENGAGEMENT_REPORT_MARKET_LIST,
    fetchCoWorkerEngagementReportMarketList
  ),
  takeLatest(
    constants.FETCH_PUBLISHED_UNPUBLISHED_PPSIS,
    fetchPublishedUnpublishedPpsis
  ),
  takeLatest(constants.FETCH_PPSIS_REVIEW_SUMMARY, fetchPpsisReviewSummary),
  takeLatest(constants.NAVIGATE_TO_REVIEW, fetchNumberOfObjectsForReview),
  takeLatest(constants.FETCH_PPSI, fetchPpsi),
  takeLatest(constants.FETCH_PPSI_GLOBAL, fetchGlobalPpsi),
  takeLatest(constants.FETCH_PPSI_GLOBAL_COPY, fetchGlobalPpsi),
  takeLatest(constants.FETCH_GLOBAL_APPROVAL_PPSI, fetchGlobalApprovalPpsi),
  takeLatest(constants.FETCH_PPSIS, fetchPpsis),
  takeLatest(constants.FETCH_PPSIS_GLOBAL, fetchGlobalPpsis),
  takeLatest(constants.FETCH_PPSIS_NEW_GLOBAL, fetchGlobalNewPpsis),
  takeLatest(constants.FETCH_RA_PA_NIR, fetch_PA_RA_Nir),
  takeLatest(constants.UPDATES_GLOBAL_PPSIS, fetchGlobalPpsisUpdates),
  takeLatest(constants.UPDATES_PPSIS, fetchPpsisUpdates),
  takeLeading(constants.CREATE_PPSI, createPpsi),
  takeLeading(constants.SAVE_PPSI, savePpsi),
  takeLeading(constants.APPROVE_PPSI, approvePpsi),
  takeLeading(constants.APPROVE_PPSI_NIR, approvePpsiNir),
  takeLeading(constants.PUBLISH_EMPTY_PPSI, publishEmptyPpsi),
  takeLeading(constants.PUBLISH_PPSI, publishPpsi),
  takeLeading(constants.UNPUBLISH_PPSI, unpublishPpsi),
  takeLeading(constants.MARK_AS_UPTODATE_PPSI, markAsUptoDatePpsi),
  takeLeading(constants.CREATE_DRAFT_PPSI, createDraftPpsi),
  takeLeading(constants.IMPORT_IFOOD_UPDATE_PPSI, importiFoodUpdatePpsi),
  takeLeading(constants.IMPORT_GLOBAL_UPDATE_PPSI, importGlobalUpdatePpsi),
  takeLeading(constants.DISCARD_DRAFT_PPSI, discardDraftPpsi),
  takeLeading(constants.DISCARD_DRAFT_PPSI_NIR, discardDraftPpsiNir),
  takeLeading(constants.SUBMIT_FOR_REVIEW_PPSI, sendPpsiForGlobalApprove),
  takeLeading(constants.GLOBAL_APPROVE_REVIEW_PPSI, globalApprovesPpsi),
  takeLeading(constants.FETCH_RECALLED_ERROR_ONE, getRecalledError),
  takeLeading(constants.GLOBAL_REJECT_REVIEW_PPSI, globalRejectsPpsi),
  takeLeading(constants.FETCH_GLOBAL_STATUS_PPSIS, fetchGlobalStatusPpsi),
  takeLatest(constants.DELETE_PPSI, deletePpsi),
  takeLeading(constants.DELETE_PPSI_NIR, deletePpsiNir),
  takeLatest(constants.CREATE_PPSI_VARIANT, createPpsiVariant),
  takeLatest(constants.UPLOAD_BOM_REPORT, uploadBomReport),
  takeLatest(constants.FETCH_GLOBAL_PPSIS_NIR, fetchGlobalPpsisNir),
  takeLeading(constants.CREATE_PPSI_FROM_GLOBAL_NIR, createPpsiFromGlobalNir),
  // takeLatest(constants.FETCH_GLOBAL_PPI_IFS, fetchGlobalPpisIfs),
  takeLatest(constants.FETCH_MARKET_DISH_LOGO, fetchMarketDishLogo),
  takeLeading(constants.SAVE_AVAILABILITY_TAB, saveAvailabilityTab)
];
